import { L2RToggleButtonGroup, styled, Typography } from "@l2r-front/l2r-ui"

import { CampaignDetailsTable, CampaignDetailsTableSkeleton } from "../../components/CampaignDetailsTable"
import { Map as MapComponent } from "../../containers/Map"

export const Map = styled(MapComponent)({
    height: "100%",
    width: "100%",
    marginLeft: "auto",
})

export const Wrapper = styled("div")({
    position: "relative",
    display: "flex",
    width: "100%",
    height: "100%",
})

export const Table = styled(CampaignDetailsTable)(({ theme }) => ({
    zIndex: 10,
    backgroundColor: theme.palette["common/white_states"].main,
    position: "absolute",
}))


export const TableSkeleton = styled(CampaignDetailsTableSkeleton)(({ theme }) => ({
    zIndex: 10,
    backgroundColor: theme.palette["common/white_states"].main,
    position: "absolute",
}))

export const ToggleButtonGroup = styled(L2RToggleButtonGroup)({
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    top: 100,
    right: 30,
    width: "fit-content",
    backgroundColor: "white",
    zIndex: 11,

    "& .MuiButtonBase-root": {
        width: 90,
    },
})

interface ValueProps {
    selected?: boolean
}

export const Value = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "selected",
})<ValueProps>(({ selected, theme }) => ({
    color: selected
        ? theme.palette["common/white_states"].main
        : theme.palette["text/primary"].main,
}))